import { usePostHog } from "posthog-js/react"
import { type TPosthogFeatureKey } from "../constants/feature-flags"

export default function usePostHogFeatureFlags(flag: TPosthogFeatureKey) {
  const postHog = usePostHog()

  return postHog?.isFeatureEnabled(flag) ?? false
}
